module.exports = __webpack_public_path__ + "img/shop_question_code@2x.555a308c.png";